import React, { useEffect, useState } from "react";
import "./index.scss";
import newuser from "@/assets/images/newuser.png";
// import hhnewuser from '@/assets/images/hhnewuser.png'
// import HeaderWeb from '@/components/headerweb'
import request from "@/utils/request";
import { Button, Icon, Toast } from "antd-mobile";
import {
  getLocationSearch,
  createNonceStr,
  md5,
  rewardDesForArr,
  isIosOrA,
  isWeiXin,
} from "@/utils/utils";
// import { appDownload } from "@/utils/appDownload";
import { connect } from "react-redux";
import { inviteeRewardDescApi,appDownload } from "@/api";
const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});
const NewUser = (props) => {
  // let { tenantTag } = getLocationSearch()
  let { phone, token } = props.match.params;
  let [desc, setDesc] = useState([]);
  let [iosAppDownloadUrl, setIosAppDownloadUrl] = useState("");
  let [androidAppDownloadUrl, setAndroidAppDownloadUrl] = useState("");
  let [show, setShow] = useState(false);
  let tenantTag = getLocationSearch().tenantTag;
  let cxname = props.tenant;
  //下载
  const handleGoDownload = async () => {
    if (!isIosOrA() && isWeiXin()) {
      setShow(true);
      return;
    }
    // appDownload();
    // if (isIosOrA()) {
    //   window.location.href = androidAppDownloadUrl;
    // } else {
    //   window.location.href = iosAppDownloadUrl;

    // }
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.get(
      `${appDownload}?tenantTag=${tenantTag}&isIos=${!isIosOrA()}`
    );
    Toast.hide();
    if (res.data.data) {
      window.location.href = res.data.data;
      console.log(res.data.data);
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };
  //接口访问
  useEffect(() => {
    let appKey = "share_h5";
    let secret = "db6322f0-0660-4228-8f98-ae24b51c98dc";
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let getToken = token;
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${getToken}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    request
      .get(
        inviteeRewardDescApi,
        {},
        {
          appKey: appKey,
          timestamp: timestamp,
          random: random,
          token: getToken,
          sign: sign,
        }
      )
      .then((data) => {
        if (data.data.data) {
          setDesc(rewardDesForArr(data.data.data.desc));
          setIosAppDownloadUrl(data.data.data.iosAppDownloadUrl);
          setAndroidAppDownloadUrl(data.data.data.androidAppDownloadUrl);
        }
      });
    return () => {};
  }, [token]);
  return (
    <div className="new-user__box">
      {show ? (
        <div class="tips_page" onClick={() => setShow(false)}>
          <img src="https://yhyfiles.oss-cn-shanghai.aliyuncs.com/qm/share_arrow.png" />
          <span>点击屏幕右上角 ··· 按钮，在浏览器中打开下载</span>
        </div>
      ) : null}
      {/* <HeaderWeb tit='领取现金'/> */}
      <h2>Hi {phone} 用户</h2>
      <h3>欢迎来到{cxname}</h3>
      <img className="bannerimg" src={newuser} alt="" />
      <h4>赶紧出车 赢取奖励</h4>
      <h5>
        {desc.map((item, key) => (
          <em key={key}>{item}</em>
        ))}
      </h5>
      <footer>
        <button onClick={handleGoDownload}>去下载{cxname}APP</button>
      </footer>
    </div>
  );
};
export default connect(mapStateToProps)(NewUser);
